module.exports = __webpack_public_path__ + "static/testimonial-5-743a2fbbcc8f6d6b68f89adf84ac0f7c.png";